import { actions, services } from '@ehi/global-marketing-interface';
import { gmiRequest } from 'actions/request';
import { getPlatform } from 'utils/browser';
import { inflightPaymentSelector } from 'selectors/reservationSelectors';

/**
 * @name skipTheCounterStart
 * @desc Dispatcher for the GMA request that kickstarts the Skip The Counter flow.
 * @param {string} origin - the page that originated the Skip The Counter start call
 * @returns {Function}
 */
export const skipTheCounterStart =
  ({ origin }) =>
  (dispatch) =>
    dispatch(
      gmiRequest({
        action: actions.request({
          data: { params: { origin } },
          service: services.gma.reservations.skipTheCounterStart,
        }),
        loadingOverlay: true,
      })
    );

/**
 * @name skipTheCounterAbort
 * @desc Dispatcher for the GMA request that aborts the Skip The Counter flow.
 * @returns {Function}
 */
export const skipTheCounterAbort =
  ({ redirect = true } = {}) =>
  (dispatch) =>
    dispatch(
      gmiRequest({
        action: actions.request({
          service: services.gma.reservations.skipTheCounterAbort,
        }),
        loadingOverlay: true,
        redirect,
      })
    );

/**
 * @name skipTheCounterCommit
 * @desc Dispatcher for the GMA request that commits STC
 * @param {Object} formData - form data to compose commit payload (local addendum acceptance)
 *
 * @returns {Function}
 */
export const skipTheCounterCommit = (formData) => (dispatch, getState) => {
  const state = getState();
  const endpoint = { skip_the_counter: true };
  const payload = { ...formData };

  // We're setting payment_id here directly if that's in session due to a GBO implementation inconsistency with modify;
  const { payment_id } = inflightPaymentSelector(state) || {};
  if (payment_id) {
    payload.payment_method = { payment_session_id: payment_id };
  }

  return dispatch(
    gmiRequest({
      action: actions.request({
        service: services.gma.reservations.commit,
        data: { endpoint, payload },
      }),
      loadingOverlay: true,
    })
  );
};

/**
 * @name skipTheCounterConfirmSelections
 * @desc Dispatcher for the GMA request to confirm user selections in Skip The Counter flow step 1
 * @param {object} payload - Form data (with flight information)
 * @returns {Function}
 */
export const skipTheCounterConfirmSelections = (payload) => (dispatch) =>
  dispatch(
    gmiRequest({
      action: actions.request({
        data: { payload },
        service: services.gma.reservations.skipTheCounterConfirmSelections,
      }),
      loadingOverlay: true,
    })
  );

/**
 * @name getSkipTheCounterCard
 * @desc Dispatcher for the GMA request to skipTheCounterCard mobile wallet pass
 * @param {object} payload - Form data (with reservation details like fname,lname, confirmationId)
 * @returns {Function}
 */
export const getSkipTheCounterCardPass =
  ({ firstName, lastName, confirmationNumber }) =>
  (dispatch) =>
    dispatch(
      gmiRequest({
        action: actions.request({
          data: {
            params: {
              firstName,
              lastName,
              confirmationNumber,
              policiesFormattedText: true,
            },
          },
          opts: {
            headers: {
              PLATFORM: getPlatform(),
            },
          },
          service: services.gma.mobileWallet.getSkipTheCounterCard,
        }),
        loadingOverlay: true,
      })
    );
